import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';               // ← use the helper file

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
        {/* <ReactQueryDevtools /> */}
    </QueryClientProvider>
);

reportWebVitals();
